<template>
  <div class="mt-20">
    <h5 class="text-bold">Adjust Curly Configuration</h5>
    <div class="row">
      <div id="fabric-id-input" class="col-md-12 mt-20">
        <label>Fabric</label>
        <v-select
          class="select-fabric"
          :options="fabrics"
          v-model="productOrder.configuration.fabric_id"
          label="production_name"
          :reduce="(fabrics) => fabrics.id"
          placeholder="Select Fabric" />

        <small v-if="errors.fabric_id" class="text-danger">Required Fabric</small>

      </div>

      <div id="contrast-fabric-id-input" class="col-md-12 mt-20">
        <label>Contrast Fabric</label>
        <v-select
          class="select-fabric"
          :options="fabrics"
          v-model="productOrder.configuration.contrast_fabric_id"
          label="production_name"
          :reduce="(fabrics) => fabrics.id"
          placeholder="Select Fabric"/>

        <small v-if="errors.contrast_fabric_id" class="text-danger">Required Contrast Fabric</small>
      </div>

      <div id="length-input" class="col-md-12 mt-20">
        <div class="form-group">
          <label>Length</label>
          <input
            type="number"
            class="form-control"
            name="length"
            v-model="productOrder.configuration.length"
            placeholder="Length in meter" />

          <small v-if="errors.length" class="text-danger">Required Length</small>
        </div>
      </div>

      <div class="col-md-12 mt-20">
        <button class="btn btn-primary btn-block" @click="updateCurly">
          Update Curly
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["productOrder"],

  data() {
    return {
      fabrics: [],
      errors: {},
    };
  },

  mounted() {
    this.getFabrics();
  },

  methods: {
    async getFabrics() {
      let res = await axios.get("/v2/fabrics?as_dropdown=1");
      this.fabrics = res.data.data.collection;
    },

    async updateCurly() {
      try {
          this.errors = {};
          let res = await axios.post(`product_orders/update-order-configuration/${this.productOrder.id}`, this.productOrder.configuration);
          if (res) {
            toastr.success("Successfully Updated");
          }
      } catch (error) {
        this.errors = error.response.data.errors;
      }
    },

  },
};
</script>
